import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";
import { Formik } from "formik";

import { formatNumberWithCommas } from "../../utils";
import ModalContainer from "../../components/ModalContainer";
import TableInvoices from "../../pages/varo/orders/orderPayments/tableInvoices";
import { getOrderType } from "../../models/ReportOperatorSalary";

const TableOrderInvoicesReport = ({ invoices }) => {
  const [openModalInfo, setOpenModalInfo] = useState(null);
  const [modalType, setModalType] = useState({ title: "", component: null });
  const tableInvoicesRef = useRef(null);

  const openModal = (invoice, type) => {
    const orderId = invoice.order_id || invoice.orderVial_id;

    if (!orderId) {
      console.error("order_id no está definido:", invoice);
      return;
    }

    const folio = invoice.Order?.folio
      ? invoice.Order.folio.toString().padStart(5, "0")
      : invoice.OrderVial?.folio ?? orderId.toString();

    setOpenModalInfo({ orderId, type });

    if (type === "invoices") {
      setModalType({
        title: `Facturas de la orden con folio: ${folio}`,
        component: (
          <>
            <h5 className="mt-10px text-start">
              <i className="fa-solid fa-file-invoice"></i> Facturas a CONTADO
            </h5>
            <Formik initialValues={{ payments: [] }} onSubmit={() => {}}>
              <TableInvoices
                ref={tableInvoicesRef}
                paymentTypeCode="CONTADO"
                valuesKey="payments"
                disabled={true}
                orderId={orderId}
                tipoOrden={
                  invoice.tipo === "Varo Express" ? "ordenVial" : invoice.tipo
                }
              />
            </Formik>

            <h5 className="mt-10px text-start">
              <i className="fa-solid fa-file-invoice"></i> Facturas a CRÉDITO
            </h5>
            <Formik initialValues={{ payments: [] }} onSubmit={() => {}}>
              <TableInvoices
                ref={tableInvoicesRef}
                paymentTypeCode="CREDITO"
                valuesKey="payments"
                disabled={true}
                orderId={orderId}
                tipoOrden={
                  invoice.tipo === "Varo Express" ? "ordenVial" : invoice.tipo
                }
              />
            </Formik>
          </>
        ),
      });
    }
  };

  const closeModal = () => {
    setOpenModalInfo(null);
    setModalType({ title: "", component: null });
  };

  return (
    <div className="table-responsive mb-3">
      <table className="table table-hover table-panel text-nowrap align-middle mb-0">
        <thead className="sticky-thead table-light text-center">
          <tr>
            <th className="align-middle">Folio orden</th>
            <th className="align-middle">Factura registrada por</th>
            {/* <th className="align-middle">Plataforma</th> */}
            <th className="align-middle">Tipo de Vehículo</th> 
            <th className="align-middle">Tipo de Servicio</th>
            <th className="align-middle">Fecha de Factura</th>
            <th className="align-middle">Tipo de Factura</th>
            <th className="align-middle">Monto</th>
            <th className="align-middle">Facturas</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice) => {
            const orderId = invoice.order_id || invoice.orderVial_id;

            const folio = invoice.Order?.folio
              ? invoice.Order.folio.toString().padStart(5, "0")
              : invoice.OrderVial?.folio ?? orderId.toString();

            let tipoServicio;
            if (invoice.tipo === "Varo Express") {
              tipoServicio =
                invoice.OrderVial?.typeService?.type_service_name ?? "N/A";
            } else {
              if (invoice.Order?.typeService?.type_service_name) {
                tipoServicio = invoice.Order.typeService.type_service_name;
              } else if (invoice.Order) {
                tipoServicio = getOrderType(invoice.Order);
              } else {
                tipoServicio = "N/A";
              }
            }

            const paymentType =
              invoice?.PaymentType?.payment_type_name || "N/A";

            const fechaFactura = invoice.invoice_date
              ? (() => {
                  const [year, month, day] = invoice.invoice_date.split("-");
                  return `${day}-${month}-${year}`;
                })()
              : "N/A";


            return (
              <tr className="text-center" key={invoice.id}>
                <td>
                  <Row className="mb-2">
                    <Col md="12">
                      <Link
                        to={
                          invoice.tipo === "Varo Express"
                            ? `/orders-vial/editOrder/${orderId}`
                            : `/orders/edit/${orderId}`
                        }
                      >
                        {folio}
                      </Link>
                    </Col>
                  </Row>
                </td>
                <td>
                  {invoice.creator_invoice
                    ? `${invoice.creator_invoice.name} ${invoice.creator_invoice.first_surname}`
                    : "N/A"}
                </td>
                {/* <td>{invoice.tipo}</td> */}
                <td>
                  {invoice.tipo === "Varo Express"
                    ? (invoice.OrderVial?.vehicles?.map(v => v.VehicleModel?.VehicleType?.vehicle_type_name).join(", ") || "N/A")
                    : (invoice.Order?.Vehicles?.map(v => v.VehicleModel?.VehicleType?.vehicle_type_name).join(", ") || "N/A")}
                </td>
                <td>{tipoServicio}</td>
                <td>{fechaFactura}</td>
                <td>{paymentType}</td>
                <td>${formatNumberWithCommas(invoice.invoice_amount)}</td>
                <td>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => openModal(invoice, "invoices")}
                  >
                    Ver facturas
                  </Button>
                  <ModalContainer
                    open={
                      openModalInfo?.orderId === orderId &&
                      openModalInfo?.type === "invoices"
                    }
                    closeFn={closeModal}
                    title={modalType.title}
                    children={modalType.component}
                    size="xl"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableOrderInvoicesReport;
